export default { sha: '1d3d72152684156fde6b79cd1faf1a03c8daddaf', buildNumber: 'undefined' }
